export default __webpack_public_path__ + "static/media/add_client.bc756de2.svg";